var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPresenceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.63308 1H23.0368C23.4188 1 23.7289 1.31009 23.7289 1.69216V14.2341H4.94092V1.69216C4.94092 1.31009 5.25101 1 5.63308 1Z",
    stroke: "#2A5A16",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3079 14.2812H4.36257C3.9803 14.2812 3.67041 14.5911 3.67041 14.9734V15.457C3.67041 15.8393 3.9803 16.1492 4.36257 16.1492H24.3079C24.6901 16.1492 25 15.8393 25 15.457V14.9734C25 14.5911 24.6901 14.2812 24.3079 14.2812Z",
    stroke: "#2A5A16",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21338 4.23242H21.5314",
    stroke: "#2A5A16",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13965 6.7998H21.4577",
    stroke: "#2A5A16",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13965 9.36621H13.1236",
    stroke: "#2A5A16",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1146 15.2326C13.1744 15.0111 13.0433 14.7832 12.8219 14.7234C12.6004 14.6637 12.3725 14.7947 12.3127 15.0162L11.5808 17.7289C11.521 17.9503 11.6521 18.1783 11.8735 18.238C12.095 18.2978 12.3229 18.1667 12.3827 17.9453L13.1146 15.2326Z",
    fill: "#EBFFB3",
    stroke: "#2A5A16",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71255 16.6839C7.14836 16.6839 8.3123 15.5199 8.3123 14.0841C8.3123 12.6483 7.14836 11.4844 5.71255 11.4844C4.27675 11.4844 3.11279 12.6483 3.11279 14.0841C3.11279 15.5199 4.27675 16.6839 5.71255 16.6839Z",
    fill: "#EBFFB3",
    stroke: "#2A5A16",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4254 20.9301C10.2879 18.7678 8.23031 17.0508 5.71269 17.0508C3.19507 17.0508 1.13751 18.7673 1 20.9301H10.4258H10.4254Z",
    fill: "#EBFFB3",
    stroke: "#2A5A16",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14648 20.9306L10.6702 17.9659C10.9812 17.3609 11.7236 17.1223 12.329 17.4334C12.934 17.7444 13.1726 18.4868 12.8615 19.0922L11.9165 20.9306H9.14648Z",
    fill: "#EBFFB3",
    stroke: "#2A5A16",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresenceIcon);
export default __webpack_public_path__ + "static/media/presence_icon.cbc842e642c54db83374e563d958dd23.svg";
export { ForwardRef as ReactComponent };